export default (values) => {

  const errors = {}

  if (!values.date) errors.date = 'Date is required'

  return errors
  
}
